import {
    IFlowTheme,
    IFlowThumbnail,
    IImage,
    TActionBlocks,
    TFlowStatus
} from '~/types/model.types';
import { ICompanyResponse } from '~/types/server.types';

export type TSortBy =
    | 'name-asc'
    | 'name-desc'
    | 'date-desc'
    | 'popularity-desc'
    | 'relevance-desc';

export type TMobileFilterScreen = 'main' | 'Sort by' | 'Industries';

export type TRepoKey =
    | 'flow_gallery'
    | 'internal_templates'
    | 'prepublish_templates';

export interface IFlowTemplatePublisher {
    _id: string;
    profile_image: IImage;
    full_name: string;
    email?: string;
}

interface IFlowTemplate {
    _id: string;
    workspace_id?: string;
    template_id: string;
    title?: string;
    theme?: IFlowTheme;
    description?: string;
    project_id?: string;
    published_at?: string;
    first_published_at?: string;
    status?: TFlowStatus;
    is_template?: boolean;
    is_published?: boolean;
    flow_url?: string;
    flow_content: {
        last_action_number: number;
        last_changed_at: string;
        action_block_types: TActionBlocks[];
    };
}

export interface IFlowGalleryTemplate {
    _id: string;
    description?: string;
    header_image?: IFlowThumbnail;
    preview_image?: IImage;
    publisher: IFlowTemplatePublisher;
    industry_tags?: string[];
    tags?: string[];
    template: IFlowTemplate;
    template_id: string;
    published_template_id: string;
    publisher_website?: string;
    publisher_email?: string;
    action_block_types?: TActionBlocks[];
    title: string;
    _type?: string;
    created_at: string;
    published_at?: string;
    updated_at?: string;
    import_count: number;
    publish_company: {
        company_name: string;
    };
    system_attributes?: string[];
}

export interface IFlowGalleryFilter {
    key: string;
    name: string;
    isActive?: boolean;
    tags?: string[];
}

export enum TemplateType {
    Flow = 'flow'
}

export interface IImportedFlowTemplate {
    active_revision_id?: string;
    company_id: string;
    configuration?: any;
    created_at: string;
    draft_revision_id?: string;
    is_template?: boolean;
    owner_id?: string;
    project_id?: string;
    source_flow_id?: string;
    title: string;
    updated_at?: string;
    workspace_id?: string;
    _id: string;
}

export interface IImportedTemplateResp {
    imported_templates: IImportedFlowTemplate[];
    company: Pick<ICompanyResponse, 'flows'> & { invoices: null };
}

export interface IFlowGalleryRepositories {
    filters: IFlowGalleryFilter[];
    name: string;
    key: string;
    tags?: string[];
    system_attributes?: string[];
}

export type TImportTemplate = (
    templateId: string,
    publishedTemplateId: string,
    saveAndEdit: boolean,
    publishedTemplateTitle?: string
) => Promise<void>;

export interface ISparksPosition {
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
}

export type TFlowGalleryCardVariant = 'default' | 'minimal';

export type TFlowGalleryCardTheme = 'light' | 'dark';

export type TFlowGalleryCardSize = {
    sm: { height: number; width: number };
    md: { height: number; width: number };
};
